import { useEffect, useState } from 'react';
import { GET, GET_CLAIM_DETAIL } from '../../../../services';
import { useMutation } from '@tanstack/react-query';

export const useGetClaimDetail = ({ claimCode, getValues, reset }) => {
  const [data, setData] = useState();

  const { isPending, mutate } = useMutation({
    mutationFn: async () => {
      const response = await GET(GET_CLAIM_DETAIL(claimCode));
      return response.result;
    },
    onSuccess: (result) => {
      reset({
        ...getValues(),
        ...result?.claim,
        claimImageUrl: [{ uid: result?.claim?.claimImageUrl, url: result?.claim?.claimImageUrl }],
        receiptImageUrl: [
          { uid: result?.claim?.receiptImageUrl, url: result?.claim?.receiptImageUrl },
        ],
      });
      setData(result);
    },
  });

  useEffect(() => {
    if (claimCode) {
      mutate();
    }
  }, [claimCode]);

  return { dataSource: data, loading: isPending };
};
